<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="产品代码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            v-decorator="[
              'productCode',
              { rules: [{ required: true, message: '请输入产品代码' }] }
            ]"
            placeholder="请输入产品代码"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="产品名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="30"
            v-decorator="[
              'productName',
              {
                rules: [
                  { required: true, message: '请输入产品名称,限制30个字' }
                ]
              }
            ]"
            placeholder="请输入产品名称,限制30个字"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="收益区间类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            v-decorator="['incomeRangeType']"
            :triggerChange="true"
            placeholder="请选择收益区间类型"
            dictCode="income_range_type"
          />
        </a-form-item>
        <a-form-item
          label="产品标签"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-multi-select-tag
            mode="multiple"
            v-decorator="['productTrips']"
            :triggerChange="true"
            placeholder="请选择产品标签"
            dictCode="product_trips"
          />
        </a-form-item>
        <a-form-item
          label="启用状态"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            v-decorator="[
              'status',
              { rules: [{ required: true, message: '请选择启用状态' }] }
            ]"
            :triggerChange="true"
            placeholder="请选择启用状态"
            dictCode="obj_status"
          />
        </a-form-item>
        <a-form-item
          label="按钮文案"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="5"
            v-decorator="['buttonCopy']"
            placeholder="请输入按钮文案,限制5个字"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="跳转路径"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            id="skipUrl"
            v-decorator="['skipUrl']"
            placeholder="请输入跳转路径"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="备用字段1"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="100"
            id="alternateField1"
            v-decorator="['alternateField1']"
            placeholder="请输入备用字段1,限制100个字"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="备用字段2"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="100"
            id="alternateField2"
            v-decorator="['alternateField2']"
            placeholder="请输入备用字段2,限制100个字"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="备用字段3"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="100"
            id="alternateField3"
            v-decorator="['alternateField3']"
            placeholder="请输入备用字段3,限制100个字"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import { getAction, httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
import moment from 'moment';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';

export default {
  name: 'ProductManageModal',
  components: {
    JDate,
    JMultiSelectTag
  },
  props: {},
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      labelValue: '',
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/product/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/product/edit'
      }
    };
  },
  created() {},
  /*watch: {
      model(newVal, oldVal) {
        this.reloadDataSource()
      }
    },*/
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      console.log(record);
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'productCode',
            'productName',
            'incomeRangeType',
            'productTrips',
            'status',
            'buttonCopy',
            'skipUrl',
            'alternateField1',
            'alternateField2',
            'alternateField3'
          )
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let formData = Object.assign(this.model, values);
          console.log('表单提交数据', formData);
          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'productCode',
          'productName',
          'incomeRangeType',
          'productTrips',
          'status',
          'buttonCopy',
          'skipUrl',
          'alternateField1',
          'alternateField2',
          'alternateField3'
        )
      );
    }
  }
};
</script>
